import { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const images = [
    './images/gallery1.png',
    './images/gallery2.png',
    './images/gallery3.png',
    './images/gallery4.png',
];

const GallerySection = () => {
    const [width, setWidth] = useState(0);
    const carouselRef = useRef(null);

    useEffect(() => {
        if (carouselRef.current) {
            setWidth(carouselRef.current.scrollWidth - carouselRef.current.offsetWidth);
        }
    }, []);

    return (
        <section id="gallery" className="w-screen overflow-hidden py-16 bg-white text-center relative">
            <motion.h2
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
                className="text-3xl md:text-4xl font-bold mb-6 text-blue-900"
            >
                Gallery
            </motion.h2>
            <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.2, ease: 'easeOut' }}
                className="text-blue-800 text-lg mb-10 px-4 md:px-20"
            >
                Explore highlights from previous INSA National Ethio Cyber Talent Summer Camps.
            </motion.p>

            {/* Full-screen carousel container */}
            <div className="overflow-hidden w-full relative">
                <motion.div
                    ref={carouselRef}
                    className="flex gap-4 px-4"
                    animate={{
                        x: [0, -width],
                    }}
                    transition={{
                        x: {
                            repeat: Infinity,
                            repeatType: 'loop',
                            duration: 20,
                            ease: 'linear',
                        },
                    }}
                    style={{ display: 'flex' }}
                >
                    {[...images, ...images].map((src, index) => (
                        <motion.div
                            key={index}
                            className="flex-shrink-0 w-full sm:w-72 md:w-80 lg:w-96 transition-transform duration-300"
                            whileHover={{ scale: 1.05 }}
                        >
                            <img
                                src={src}
                                alt={`Gallery image ${index % images.length + 1}`}
                                className="w-full h-48 sm:h-56 md:h-64 object-cover rounded-xl shadow-md"
                            />
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default GallerySection;
